"use client";
import { Dispatch, SetStateAction } from "react";
import { GeoLocationType } from "../contexts";

const defaultSettings = {
  enableHighAccuracy: true,
  timeout: Infinity,
  maximumAge: 0,
};

export function isSupported() {
  return (
    typeof navigator !== "undefined" &&
    typeof navigator.geolocation !== "undefined"
  );
}

// Clears the watcher
export function stopWatchingForLocation(
  position: GeoLocationType,
  setPosition: Dispatch<SetStateAction<GeoLocationType>>,
) {
  if (position.watcher) {
    navigator.geolocation.clearWatch(position.watcher);
    setPosition({
      ...position,
      watcher: undefined,
    });
  }
}

// Checks for location/prompts permission. If watch is set to true, make sure to clear the watch afterward.
export function getUserLocation(
  location: GeoLocationType,
  setLocation: Dispatch<SetStateAction<GeoLocationType>>,
  watch = false,
  settings: PositionOptions = defaultSettings,
) {
  const onChange: PositionCallback = ({ coords, timestamp }) => {
    setLocation({
      ...location,
      result: {
        coords: {
          lat: coords.latitude,
          lon: coords.longitude,
          accuracy: coords.accuracy,
        },
        error: undefined,
        timestamp,
      },
      isLoading: false,
    });
  };

  const onError: PositionErrorCallback = (error) => {
    setLocation({
      ...location,
      result: {
        ...location.result,
        error: error.message,
      },
      isLoading: false,
    });
  };

  if (!isSupported()) {
    location.isSupported &&
      setLocation({
        ...location,
        isSupported: false,
      });
    return;
  }

  if (watch) {
    setLocation({
      ...location,
      isLoading: true,
      watcher: navigator.geolocation.watchPosition(onChange, onError, settings),
    });
  } else {
    setLocation({
      ...location,
      isLoading: true,
    });
    navigator.geolocation.getCurrentPosition(onChange, onError, settings);
  }
}
